import { getLocale } from '../date-fns';

/** Formats a duration in seconds with abbreviated units, rounding down to whole minutes. */
export const formatSecondsToHoursMinutes = (seconds: number) => {
    const totalMinutes = Math.floor(Math.max(seconds, 0) / SECONDS_PER_MINUTE);
    const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
    const minutes = totalMinutes % MINUTES_PER_HOUR;

    if (hours && minutes) {
        return `${formatUnit(hours, 'hour')} ${formatUnit(minutes, 'minute')}`;
    }

    if (hours) {
        return formatUnit(hours, 'hour');
    }

    return formatUnit(minutes, 'minute');
};

const formatUnit = (value: number, unit: 'hour' | 'minute') => {
    return new Intl.NumberFormat(getLocale()?.code, {
        style: 'unit',
        unit,
        unitDisplay: 'short',
    }).format(value);
};

const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
